import { render, staticRenderFns } from "./Pagfor.vue?vue&type=template&id=6fcc7973&"
import script from "./Pagfor.vue?vue&type=script&lang=js&"
export * from "./Pagfor.vue?vue&type=script&lang=js&"
import style0 from "./Pagfor.vue?vue&type=style&index=0&id=6fcc7973&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports